export const ADD_FORM_CARD_ORIGINAL_INDEX = 'addFormCardOriginalIndex';
export const RESET_REDUX_STORE = 'resetReduxStore1';
export const CHANGE_FORM_CARD_POSITION_ORIGINAL_INDEX =
  'changeFormCardPositioninOriginalIndArray';
export const ADD_QUESTION_TEXT = 'addQuestionText';
export const ADD_FORM_CARD_DATA_DB = 'addFormCardsDataDb';
export const ADD_FORM_CARD_QUESTION_DATA = 'addFormCardQuestionData';
export const DELETE_FORM_CARD_DATA_BY_KEY = 'deleteFormCard';
export const ADD_REF_VALUES_BY_KEY = 'addRefvalues';
export const ADD_REF_VALUE_ACTION = 'addAction';
export const REORDER_FORM_CARDS_R = 'REORDER_FORM_CARDS_R';
